import { loadComponentColors } from './componentColors'

let componentColors: Record<string, string> | undefined

export const color = (componentName: string): string => {
  if (!componentColors) {
    componentColors = loadComponentColors()
  }

  if (!componentColors[componentName]) {
    throw new Error(`Component color "${componentName}" does not exist.`)
  }

  return componentColors[componentName]
}

export const hexToRgb = (hex: string, alpha: number = 1): string => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
